import styled from '@emotion/styled';
import { NextIcon } from 'components/Icon';

const CategoryNext = styled(NextIcon)({
  position: 'absolute',
  right: 24
})

export {
  CategoryNext,
}